import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import connectApi from '../../api/connectApi'
import { constants } from '../../helpers'
import { FcMetricsPayload } from '../../storeTypes'

export const fcMetricsAction = createAsyncThunk<
    FcMetricsPayload,
    string,
    { rejectValue: string }
>('fcMetrics/fcMetricsAction', async (fcCode: string, { rejectWithValue }) => {
    const { FC_METRICS } = constants.endpoints
    try {
        const response = await connectApi.get(FC_METRICS, {
            params: { fc_code: fcCode }
        })
        return response.data as FcMetricsPayload
    } catch (error: unknown) {
        const errorMessage =
            error instanceof Error ? error.message : 'An error occurred'
        return rejectWithValue(errorMessage)
    }
})

type FcMetricsState = {
    loading: boolean
    data: FcMetricsPayload | undefined
    error: string | undefined
}

const initialState: FcMetricsState = {
    loading: true,
    data: undefined,
    error: undefined
}

export const fcMetricsSlice = createSlice({
    name: 'fcMetrics',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fcMetricsAction.pending, (state) => {
                state.loading = true
                state.data = undefined
                state.error = undefined
            })
            .addCase(fcMetricsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload
                state.error = undefined
            })
            .addCase(fcMetricsAction.rejected, (state, action) => {
                state.loading = false
                state.data = undefined
                state.error = action.payload ?? 'An error occurred'
            })
    }
})

export default fcMetricsSlice.reducer
